"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebLinkSchema = void 0;
exports.WebLinkSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/web-link.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "WebLink",
    "description": "Link to another website",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:web-link"
            ]
        },
        "href": {
            "type": "string",
            "format": "iri"
        },
        "markup": {
            "type": "array",
            "items": {
                "type": "string",
                "enum": [
                    "emphasized"
                ]
            }
        },
        "text": {
            "type": "string"
        }
    },
    "required": [
        "href",
        "text",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2ViLWxpbmsuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvYXR0cmlidXRlcy93ZWItbGluay5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxhQUFhLEdBQUc7SUFDM0IsS0FBSyxFQUFFLGlFQUFpRTtJQUN4RSxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxTQUFTO0lBQ2xCLGFBQWEsRUFBRSx5QkFBeUI7SUFDeEMsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04scUJBQXFCO2FBQ3RCO1NBQ0Y7UUFDRCxNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixRQUFRLEVBQUUsS0FBSztTQUNoQjtRQUNELFFBQVEsRUFBRTtZQUNSLE1BQU0sRUFBRSxPQUFPO1lBQ2YsT0FBTyxFQUFFO2dCQUNQLE1BQU0sRUFBRSxRQUFRO2dCQUNoQixNQUFNLEVBQUU7b0JBQ04sWUFBWTtpQkFDYjthQUNGO1NBQ0Y7UUFDRCxNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtTQUNqQjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLE1BQU07UUFDTixNQUFNO0tBQ1A7Q0FDRixDQUFBIn0=